export default __webpack_public_path__ + "static/media/message_send.118bf266.svg";